import { __assign, __awaiter, __generator } from 'tslib';
import React__default, { useEffect, useState } from 'react';
import { createMediaShareToken, KpkApiShareTokenExportDefinition, deleteMediaShareToken } from '@keepeek/api-client';
import { Box, Toolbar, Button, Typography } from '@mui/material';
import Axios from 'axios';
import clsx from 'clsx';
import { useSnackbar } from 'notistack';
import { useTranslation } from 'react-i18next';
import ConfirmationDialog from '../ConfirmationDialog/index.js';
import useElement from '../providers/elements/hooks.js';
import { useLocale } from '../providers/locale/hooks.js';
import useShareTokens, { useShareTokenTemplates } from '../providers/shareTokens/hooks.js';
import KCreationDialog from './components/KCreationDialog/index.js';
import { convertFormikValuesToShareTokenApi } from './components/KCreationDialog/utils.js';
import KTableContainer from './containers/KTableContainer/index.js';

var KFGeneralPublicSharing = function KFGeneralPublicSharing(_a) {
    var _b;
    var elementId = _a.elementId, dataLocale = _a.dataLocale, tableContainerComponent = _a.tableContainerComponent, _c = _a.testId, testId = _c === void 0 ? "KFGeneralPublicSharing" : _c, className = _a.className, sx = _a.sx, KIcon = _a.KIcon;
    var setDataLocale = useLocale().setDataLocale;
    useEffect(function () {
        setDataLocale({
            locale: dataLocale
        });
    }, [setDataLocale, dataLocale]);
    var t = useTranslation("refront-components").t;
    var enqueueSnackbar = useSnackbar().enqueueSnackbar;
    var _d = useState(false), createShareDisabled = _d[0], setCreateShareDisabled = _d[1];
    var _e = useState({
        dialogOpen: false,
        shareToken: null
    }), creationUpdateAction = _e[0], setCreationUpdateAction = _e[1];
    var _f = useState({
        dialogOpen: false,
        shareToken: null
    }), deleteAction = _f[0], setDeleteAction = _f[1];
    var _g = useShareTokens(elementId), loading = _g.loading, error = _g.error, shareTokens = _g.shareTokens, refreshShareTokens = _g.refreshShareTokens, pageSize = _g.pageSize, pageNumber = _g.pageNumber, setPageNumber = _g.setPageNumber, setPageSize = _g.setPageSize, totalCount = _g.totalCount;
    var element = useElement(elementId).element;
    var _h = useShareTokenTemplates(), setCurrentTemplateId = _h.setCurrentTemplateId, shareTokenTemplates = _h.shareTokenTemplates, shareTokenTemplateDomains = _h.shareTokenTemplateDomains;
    function handlePageSizeChange(pageSize) {
        setPageSize(pageSize);
    }
    function handlePageNumberChange(pageNumber) {
        setPageNumber(pageNumber);
    }
    function handleDeleteRefreshToken(shareToken) {
        setDeleteAction({
            dialogOpen: true,
            shareToken: shareToken
        });
    }
    function handleEditRefreshToken(shareToken) {
        setCreationUpdateAction(__assign(__assign({}, creationUpdateAction), { dialogOpen: true, shareToken: shareToken }));
    }
    useEffect(function () {
        if (error) {
            console.error("can't load general public sharing", error);
            enqueueSnackbar(t("components.kf-general-public-sharing.request.error"), {
                variant: "error"
            });
        }
    }, [enqueueSnackbar, error, t]);
    function handleAddButtonClick() {
        return __awaiter(this, void 0, void 0, function () {
            var shareValues, errorMessage;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        setCreateShareDisabled(true);
                        if (!((shareTokenTemplates === null || shareTokenTemplates === void 0 ? void 0 : shareTokenTemplates.length) === 1 && (shareTokenTemplateDomains === null || shareTokenTemplateDomains === void 0 ? void 0 : shareTokenTemplateDomains.length) === 1)) return [3 /*break*/, 5];
                        shareValues = {
                            title: "".concat(element === null || element === void 0 ? void 0 : element.id, "-").concat(element === null || element === void 0 ? void 0 : element.title),
                            templateId: shareTokenTemplates[0].id,
                            exportDefinition: KpkApiShareTokenExportDefinition.HD,
                            domainId: shareTokenTemplateDomains[0].id,
                            token: "",
                            suffix: "",
                            manualActivate: true,
                            activationDate: null,
                            deactivationDate: null
                        };
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, createMediaShareToken(Axios, __assign({ mediaId: elementId }, convertFormikValuesToShareTokenApi(shareValues)))];
                    case 2:
                        _a.sent();
                        refreshShareTokens();
                        enqueueSnackbar(t("components.kf-general-public-sharing.creation.success"), {
                            variant: "success"
                        });
                        return [3 /*break*/, 4];
                    case 3:
                        _a.sent();
                        errorMessage = t("components.kf-general-public-sharing.creation.error.default");
                        enqueueSnackbar(errorMessage, {
                            variant: "error"
                        });
                        return [3 /*break*/, 4];
                    case 4:
                        setCreateShareDisabled(false);
                        return [3 /*break*/, 6];
                    case 5:
                        setCreationUpdateAction(__assign(__assign({}, creationUpdateAction), { dialogOpen: true, shareToken: null }));
                        _a.label = 6;
                    case 6: return [2 /*return*/];
                }
            });
        });
    }
    function handleDialogClose(needRefresh) {
        setCreateShareDisabled(false);
        setCreationUpdateAction(__assign(__assign({}, creationUpdateAction), { dialogOpen: false }));
        if (needRefresh) {
            refreshShareTokens();
        }
    }
    function handleDeleteDialog(dialogConfirmation) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!dialogConfirmation) return [3 /*break*/, 4];
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, deleteMediaShareToken(Axios, {
                                mediaId: elementId,
                                shareTokenId: (_a = deleteAction.shareToken) === null || _a === void 0 ? void 0 : _a.tokenValue
                            })];
                    case 2:
                        _b.sent();
                        refreshShareTokens();
                        enqueueSnackbar(t("components.kf-general-public-sharing.delete.success"), {
                            variant: "success"
                        });
                        return [3 /*break*/, 4];
                    case 3:
                        _b.sent();
                        enqueueSnackbar(t("components.kf-general-public-sharing.delete.error"), {
                            variant: "error"
                        });
                        return [3 /*break*/, 4];
                    case 4:
                        setDeleteAction(__assign(__assign({}, deleteAction), { dialogOpen: false }));
                        return [2 /*return*/];
                }
            });
        });
    }
    var TableContainerComponent = tableContainerComponent || KTableContainer;
    return (React__default.createElement(Box, { className: clsx("KFGeneralPublicSharing", className), "data-testid": testId, sx: sx },
        React__default.createElement(Toolbar, { disableGutters: true, sx: {
                px: 0
            } },
            React__default.createElement(Button, { variant: "contained", disabled: createShareDisabled, color: "primary", onClick: handleAddButtonClick, size: "small" }, t("components.kf-general-public-sharing.add.button"))),
        !error && (React__default.createElement(TableContainerComponent, { loading: loading, totalCount: totalCount, rows: shareTokens, onPageSizeChange: handlePageSizeChange, onPageNumberChange: handlePageNumberChange, pageSize: pageSize, pageNumber: pageNumber, onDeleteShareToken: handleDeleteRefreshToken, onEditShareToken: handleEditRefreshToken, KIcon: KIcon })),
        React__default.createElement(KCreationDialog, { open: creationUpdateAction.dialogOpen, onClose: handleDialogClose, elementId: elementId, element: element, shareTokenToUpdate: creationUpdateAction.shareToken || undefined, setCurrentTemplateId: setCurrentTemplateId, shareTokenTemplateDomains: shareTokenTemplateDomains, shareTokenTemplates: shareTokenTemplates, KIcon: KIcon }),
        React__default.createElement(ConfirmationDialog, { onClose: handleDeleteDialog, open: deleteAction.dialogOpen, cancelVariant: "text", okLabel: t("components.kf-general-public-sharing.delete.confirmation.ok.button"), cancelLabel: t("components.kf-general-public-sharing.delete.confirmation.cancel.button"), title: t("components.kf-general-public-sharing.delete.confirmation.title"), customButton: Button },
            React__default.createElement(Typography, null, t("components.kf-general-public-sharing.delete.confirmation.body", {
                shareTitle: (_b = deleteAction.shareToken) === null || _b === void 0 ? void 0 : _b.title
            })))));
};

export { KFGeneralPublicSharing as default };
//# sourceMappingURL=index.js.map
